var React = require('react');

function CheckInline (props) {
    return React.createElement("svg",props,[React.createElement("ellipse",{"cx":"14","cy":"13.5","rx":"14","ry":"13.5","fill":"#F29100","key":0}),React.createElement("path",{"d":"M13.3077 19L11.4555 20.6791C11.9294 21.2019 12.6021 21.5 13.3077 21.5C14.0132 21.5 14.686 21.2019 15.1598 20.6791L13.3077 19ZM4.14785 12.6185L11.4555 20.6791L15.1598 17.3209L7.85215 9.26025L4.14785 12.6185ZM15.1598 20.6791L27.8522 6.67915L24.1479 3.32085L11.4555 17.3209L15.1598 20.6791Z","fill":"white","key":1})]);
}

CheckInline.defaultProps = {"width":"28","height":"27","viewBox":"0 0 28 27","fill":"none"};

module.exports = CheckInline;

CheckInline.default = CheckInline;
